import { useLazyQuery } from '@apollo/client'

import { ExportButton as BaseExportButton } from 'components'
import { MiscUtils } from 'utils'
import {
  CropFilterContext,
  HistoricalSeasonFilterContext,
  RegionFilterContext,
  VarietyFilterContext,
} from 'contexts'
import { HarvestFiltersContext } from 'features/MainRouter/contexts'

import {
  HARVEST_BY_PRODUCER_EXPORT,
  HarvestByProducerExport,
  HarvestByProducerExportVariables,
} from './api'

export const ExportButton = () => {
  const { region } = RegionFilterContext.useRegionFilterContext()
  const { selectedCrop } = CropFilterContext.useCropFilterContext()
  const { selectedVarietyId } = VarietyFilterContext.useVarietyFilterContext()
  const { selectedHistoricalSeason } =
    HistoricalSeasonFilterContext.useHistoricalSeasonFilterContext()
  const { company, subregion } = HarvestFiltersContext.useHarvestFiltersContext()

  const cropId = selectedCrop?.id

  const [getHarvestByProducerAnalyticsData, { loading }] = useLazyQuery<
    HarvestByProducerExport,
    HarvestByProducerExportVariables
  >(HARVEST_BY_PRODUCER_EXPORT, {
    onCompleted: response => window.open(response.harvestByProducerExport.url),
  })
  return (
    <BaseExportButton
      loading={loading}
      disabled={!cropId}
      handlePress={() =>
        getHarvestByProducerAnalyticsData({
          variables: {
            regionId: region?.id,
            subregionId: subregion?.id,
            companyId: company?.id,
            cropId: cropId!,
            seasonStartRange: selectedHistoricalSeason?.startRange,
            seasonEndRange: selectedHistoricalSeason?.endRange,
            varietyId: MiscUtils.formatVarietyId(selectedVarietyId),
          },
        })
      }
    />
  )
}
